import { useState } from "react";
import { Modal } from "../UI";
import { DateRange } from "react-date-range";
import moment from "moment";

import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import { mq } from "../responsive";

/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";

const DatePicker = ({ style, onChange }) => {
  const [config, setConfig] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  const generateRangeText = (data) =>
    `${moment(data.startDate).format("Do MMM")} - ${moment(data.endDate).format(
      "Do MMM"
    )}`;

  const handleDateChange = (item) => {
    setConfig([item.selection]);
    onChange();
  };

  return (
    <div css={style}>
      <Modal
        trigger={
          <span
            css={{
              whiteSpace: "nowrap",
              padding: "0 1rem",
              [mq.md]: { fontWeight: 500 },

              [mq.lg]: {
                padding: "0 3rem",
              },
            }}
          >
            {generateRangeText(config[0])}
          </span>
        }
      >
        <DateRange
          onChange={handleDateChange}
          moveRangeOnFirstSelection={false}
          ranges={config}
          months={2}
        />
      </Modal>
    </div>
  );
};

export default DatePicker;
